import { render, staticRenderFns } from "./TextV1.vue?vue&type=template&id=4f2c3fee&"
import script from "./TextV1.vue?vue&type=script&lang=js&"
export * from "./TextV1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../Breeze.Portal.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports